import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { getLocalAccessToken } from "../../utils/helpers";
import API_BASE_URL from "../../utils/config";

const useGetSectionImage = ({ id }) => {
  const [imageSrc, setImageSrc] = useState("");
  const getSectionImage = useCallback(async () => {
    if (!id) return;
    const authToken = getLocalAccessToken();

    try {
      const response = await axios.get(`${API_BASE_URL}/images/${id}`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
        responseType: "blob",
      });
      const url = URL.createObjectURL(response.data);
      setImageSrc(url);
    } catch (error) {
      console.error(error?.message);
    }
  }, [id]);

  useEffect(() => {
    getSectionImage();
    return () => {
      setImageSrc("");
    };
  }, [getSectionImage]);

  return {
    imageSrc,
  };
};

export default useGetSectionImage;
